module.exports = __webpack_public_path__ + "static/cr-announcement-hero-desktop-55836371ac32e38ec9d1f62c26efef85.png";